'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _reports = require('./reports.component');

var _reports2 = _interopRequireDefault(_reports);

var _reporting = require('./reporting.Service');

var _reporting2 = _interopRequireDefault(_reporting);

var _showroomTraffic = require('./showroomTraffic/showroomTraffic');

var _showroomTraffic2 = _interopRequireDefault(_showroomTraffic);

var _favoriteReports = require('./favoriteReports/favoriteReports');

var _favoriteReports2 = _interopRequireDefault(_favoriteReports);

var _salesReport = require('./salesReport/salesReport');

var _salesReport2 = _interopRequireDefault(_salesReport);

var _allEnquiries = require('./allEnquiries/allEnquiries');

var _allEnquiries2 = _interopRequireDefault(_allEnquiries);

var _dealTimeline = require('./dealTimeline/dealTimeline');

var _dealTimeline2 = _interopRequireDefault(_dealTimeline);

var _deliveryPastEnquiries = require('./deliveryPastEnquiries/deliveryPastEnquiries');

var _deliveryPastEnquiries2 = _interopRequireDefault(_deliveryPastEnquiries);

var _appraisalAnalysis = require('./appraisalAnalysis/appraisalAnalysis');

var _appraisalAnalysis2 = _interopRequireDefault(_appraisalAnalysis);

var _contactsDataEntryMetric = require('./contactsDataEntryMetric/contactsDataEntryMetric');

var _contactsDataEntryMetric2 = _interopRequireDefault(_contactsDataEntryMetric);

var _lostDealAnalysis = require('./lostDealAnalysis/lostDealAnalysis');

var _lostDealAnalysis2 = _interopRequireDefault(_lostDealAnalysis);

var _marketingConversion = require('./marketingConversion/marketingConversion');

var _marketingConversion2 = _interopRequireDefault(_marketingConversion);

var _salesPersonConversion = require('./salesPersonConversion/salesPersonConversion');

var _salesPersonConversion2 = _interopRequireDefault(_salesPersonConversion);

var _showroomDetailed = require('./showroomDetailed/showroomDetailed');

var _showroomDetailed2 = _interopRequireDefault(_showroomDetailed);

var _testDrives = require('./testDrives/testDrives');

var _testDrives2 = _interopRequireDefault(_testDrives);

var _tradePriceList = require('./tradePriceList/tradePriceList');

var _tradePriceList2 = _interopRequireDefault(_tradePriceList);

var _leadTracker = require('./leadTracker/leadTracker');

var _leadTracker2 = _interopRequireDefault(_leadTracker);

var _reportSummary = require('./reportSummary/reportSummary');

var _reportSummary2 = _interopRequireDefault(_reportSummary);

var _reportData = require('./reportData/reportData');

var _reportData2 = _interopRequireDefault(_reportData);

var _financeDetail = require('./financeDetail/financeDetail');

var _financeDetail2 = _interopRequireDefault(_financeDetail);

var _financeSummary = require('./financeSummary/financeSummary');

var _financeSummary2 = _interopRequireDefault(_financeSummary);

var _bankSummary = require('./bankSummary/bankSummary');

var _bankSummary2 = _interopRequireDefault(_bankSummary);

var _modelEnquiry = require('./modelEnquiry/modelEnquiry');

var _modelEnquiry2 = _interopRequireDefault(_modelEnquiry);

var _salesTrend = require('./salesTrend/salesTrend');

var _salesTrend2 = _interopRequireDefault(_salesTrend);

var _reportableAddons = require('./reportableAddons/reportableAddons');

var _reportableAddons2 = _interopRequireDefault(_reportableAddons);

var _systemUsage = require('./adminReports/systemUsage/systemUsage');

var _systemUsage2 = _interopRequireDefault(_systemUsage);

var _enquiryPayments = require('./enquiryPayments/enquiryPayments');

var _enquiryPayments2 = _interopRequireDefault(_enquiryPayments);

var _promisesReport = require('./promisesReport/promisesReport');

var _promisesReport2 = _interopRequireDefault(_promisesReport);

var _marketingConsent = require('./marketingConsent/marketingConsent');

var _marketingConsent2 = _interopRequireDefault(_marketingConsent);

var _digitalSignatures = require('./digitalSignatures/digitalSignatures');

var _digitalSignatures2 = _interopRequireDefault(_digitalSignatures);

var _SourceOfEnquiry = require('./SourceOfEnquiry/SourceOfEnquiry');

var _SourceOfEnquiry2 = _interopRequireDefault(_SourceOfEnquiry);

var _salesMatch = require('./salesMatch/salesMatch');

var _salesMatch2 = _interopRequireDefault(_salesMatch);

var _lastLogin = require('./adminReports/lastLogin/lastLogin');

var _lastLogin2 = _interopRequireDefault(_lastLogin);

var _vehicleImports = require('./adminReports/vehicleImports/vehicleImports');

var _vehicleImports2 = _interopRequireDefault(_vehicleImports);

var _reportsUsage = require('./adminReports/reportsUsage/reportsUsage');

var _reportsUsage2 = _interopRequireDefault(_reportsUsage);

var _weeklySalesActivity = require('./weeklySalesActivity/weeklySalesActivity');

var _weeklySalesActivity2 = _interopRequireDefault(_weeklySalesActivity);

var _cashFlow = require('./cashFlow/cashFlow');

var _cashFlow2 = _interopRequireDefault(_cashFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportsModule = _angular2.default.module('reports', [_angularUiRouter2.default, _showroomTraffic2.default, _favoriteReports2.default, _salesReport2.default, _allEnquiries2.default, _dealTimeline2.default, _deliveryPastEnquiries2.default, _appraisalAnalysis2.default, _contactsDataEntryMetric2.default, _lostDealAnalysis2.default, _marketingConversion2.default, _salesPersonConversion2.default, _showroomDetailed2.default, _testDrives2.default, _tradePriceList2.default, _leadTracker2.default, _reportSummary2.default, _reportData2.default, _financeDetail2.default, _financeSummary2.default, _bankSummary2.default, _modelEnquiry2.default, _salesTrend2.default, _reportableAddons2.default, _systemUsage2.default, _enquiryPayments2.default, _promisesReport2.default, _marketingConsent2.default, _digitalSignatures2.default, _SourceOfEnquiry2.default, _salesMatch2.default, _lastLogin2.default, _vehicleImports2.default, _reportsUsage2.default, _weeklySalesActivity2.default, _cashFlow2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('reportsLanding', {
    component: 'reports',
    url: '/reports'
  });
}).service('reportingService', _reporting2.default).component('reports', _reports2.default).name;

exports.default = reportsModule;


// WEBPACK FOOTER //
// ./client/app/components/reports/reports.js